import ajax from "../utils/request";
const videoApi = {
  /********************************审核视频相关接口*********************************** */
  queryTagList(params) {
    return ajax({
      url: "/tag/pure/list",
      type: "get",
      params: params,
    });
  },
  getVideoList(params) {
    return ajax({
      url: "/vid/list",
      type: "get",
      params: params,
    });
  },
  queryHappTopList(params) {
    return ajax({
      url: "/image/list",
      type: "post",
      params: params,
    });
  },
  delHappTopList(params) {
    return ajax({
      url: "/image/delete",
      type: "post",
      params: params,
    });
  },
  updataHappTopList(params) {
    return ajax({
      url: "/image/update",
      type: "post",
      params: params,
    });
  },
  queryVidHot(params) {
    return ajax({
      url: "/vid/search",
      type: "post",
      params: params,
    });
  },
  exportVideoList(params) {
    return ajax({
      url: "/vid/export",
      type: "post",
      // responseType: "blob",
      params: params,
    });
  },
  // 视频删除接口
  deleteVideos(params) {
    return ajax({
      url: "/vid/del",
      type: "delete",
      params: params,
    });
  },
  // 单个视频审核接口
  examineVideo(params) {
    return ajax({
      url: "/vid/batch/pass",
      type: "post",
      params: params,
    });
  },
  // 批量视频审核接口
  batchReview(params) {
    return ajax({
      url: "/vid/batch/edit",
      type: "post",
      params: params,
    });
  },
  // 批量视频删除接口
  batchDelete(params) {
    return ajax({
      url: "/module/video/delete/batch",
      type: "post",
      params: params,
    });
  },
  // up主上传金币vip视频比例
  getVipAndCoin(params) {
    return ajax({
      url: "/vid/vipAndCoin",
      type: "get",
      params: params,
    });
  },
  // get获取专题
  sectionGetList(params) {
    return ajax({
      url: "/module/section/all",
      type: "get",
      params: params,
    });
  },
  // 视频编辑
  editVideoInfo(params) {
    return ajax(
      {
        url: "/vid/update",
        type: "post",
        params: params,
      },
      true
    );
  },
  // 推送为精选
  setChosen(params) {
    return ajax({
      url: "/vid/batch/update",
      type: "post",
      params: params,
    });
  },

  // 是否推荐
  setRecommend(params) {
    return ajax({
      url: "/vid/push",
      type: "post",
      params: params,
    });
  },
  // 批量是否推荐
  batchSetRecommend(params) {
    return ajax({
      url: "/vid/batch/reco",
      type: "post",
      params: params,
    });
  },
  // 取消推送
  cancelRecommend(params) {
    return ajax({
      url: "/vid/push/delete",
      type: "post",
      params: params,
    });
  },
  // 推送列表
  recommendList(params) {
    return ajax({
      url: "/vid/push/list",
      type: "get",
      params: params,
    });
  },

  // 视频上传
  uploadVideo(params) {
    return ajax({
      url: "/vid/submit",
      type: "post",
      params: params,
    });
  },
  // 精选视频推送
  pushVideo(params) {
    return ajax({
      url: "/vid/push",
      type: "post",
      params: params,
    });
  },
  // 审核不通过理由列表
  // 查询
  queryFailList(params) {
    return ajax({
      url: "/rejectTemp/vid/list",
      type: "get",
      params: params,
    });
  },
  // 新增
  addFailList(params) {
    return ajax({
      url: "/rejectTemp/vid/insert",
      type: "post",
      params: params,
    });
  },
  // 删除
  delFailList(params) {
    return ajax({
      url: "/rejectTemp/vid/del",
      type: "post",
      params: params,
    });
  },
  // 编辑
  editFailList(params) {
    return ajax({
      url: "/rejectTemp/vid/update",
      type: "post",
      params: params,
    });
  },
  // 视频审查
  videoFeviewList(params, urll) {
    return ajax({
      url: "/vid/view/" + urll,
      type: "get",
      params: params,
    });
  },
  // 获取专题
  sectionList(params) {
    return ajax({
      url: "/module/section/all",
      type: "post",
      params: params,
    });
  },
  // 批量新增视频
  batch(params) {
    return ajax({
      url: "/module/video/add/batch",
      type: "post",
      params: params,
    });
  },
  // 批量新增视频
  getVideoActivity(params) {
    return ajax({
      url: "/video_activity/box",
      type: "get",
      params: params,
    });
  },

  /**
   * 断点续传视频验证是否分片上传完毕
   * @param {*} data
   */
  uploadDotJson(params) {
    return ajax({
      url: "/vid/uploadDotJson",
      type: "post",
      params: params,
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
    });
  },
  uploadDotStream(params) {
    return ajax({
      url: "/vid/uploadDotStream",
      type: "post",
      params: params,
    });
  },
  /********************************推荐排行列表*********************************** */
  // 获取推荐排行列表
  getRecommendtopList(params) {
    return ajax({
      url: "/recommendtop/list",
      type: "get",
      params: params,
    });
  },
  // 添加推荐排行
  addRecommendtop(params) {
    return ajax({
      url: "/recommendtop/create",
      type: "post",
      params: params,
    });
  },
  // 删除推荐排行
  delRecommendtop(params) {
    return ajax({
      url: "/recommendtop/delete",
      type: "post",
      params: params,
    });
  },
  // 修改推荐排行
  updateRecommendtop(params) {
    return ajax({
      url: "/recommendtop/update",
      type: "post",
      params: params,
    });
  },
  /********************************城市列表*********************************** */
  // 删除城市
  deleteCity(params) {
    return ajax({
      url: "/vid/location/hotCity/delete",
      type: "post",
      params: params,
    });
  },
  // 获取城市列表
  getCityList(params) {
    return ajax({
      url: "/vid/location/city/list",
      type: "get",
      params: params,
    });
  },
  // 编辑
  updateCity(params) {
    return ajax({
      url: "/vid/location/city/update",
      type: "post",
      params: params,
    });
  },
  // 批量编辑标签
  batchEditTags(params) {
    return ajax({
      url: "/vid/batch/update/tags",
      type: "post",
      params: params,
    });
  },
  /********************************热门城市*********************************** */
  // 新增热门城市
  addHotCity(params) {
    return ajax({
      url: "/vid/location/hotCity/add",
      type: "post",
      params: params,
    });
  },
  // 删除热门城市
  deleteHotCity(params) {
    return ajax({
      url: "/vid/location/hotCity/delete",
      type: "delete",
      params: params,
    });
  },
  // 获取热门城市列表
  getHotCityList(params) {
    return ajax({
      url: "/vid/location/hotCity/list",
      type: "get",
      params: params,
    });
  },
  // 编辑热门城市
  editHotCity(params) {
    return ajax({
      url: "/vid/location/hotCity/update",
      type: "post",
      params: params,
    });
  },
  /********************************评论管理*********************************** */
  // 回复评论
  replyComment(params) {
    return ajax({
      url: "/comment/send",
      type: "post",
      params: params,
    });
  },
  // 请求评论管理模块配置列表
  getCommentList(params) {
    return ajax({
      url: "/comment/list",
      type: "get",
      params: params,
    });
  },
  // 请求评论管理模块封禁用户
  getCommentBan(params) {
    return ajax({
      url: "/comment/ban",
      type: "post",
      params: params,
    });
  },
  // 请求评论管理模块通过审核
  getCommentAccess(params) {
    return ajax({
      url: "/comment/access",
      type: "post",
      params: params,
    });
  },
  // 评论批量通过
  commentBatchPass(params) {
    return ajax({
      url: "/comment/batch/access",
      type: "post",
      params: params,
    });
  },
  // 删除评论
  delComment(params) {
    return ajax({
      url: "/comment/delete",
      type: "post",
      params: params,
    });
  },
  // 根据评论内容删除评论
  deleteContent(params) {
    return ajax({
      url: "/web/comment/delete",
      type: "post",
      params: params,
    });
  },
  // 根据评论内容删除评论
  // upLoadContent(params) {
  //   return ajax({
  //     url: '/comment/importExcel',
  //     type: 'post',
  //     params: params
  //   })
  // },

  //导入评论内容
  iExcel(params) {
    return ajax({
      url: "/comment/importExcel",
      type: "post",
      params: params,
    });
  },
  /********************************短视频最热*********************************** */
  // 请求推特短视频最热模块配置列表
  getVideoHotList(params) {
    return ajax({
      url: "/vid/tone/list",
      type: "get",
      params: params,
    });
  },
  // 编辑推特短视频最热
  editVideoHot(params) {
    return ajax({
      url: "/vid/tone/update",
      type: "post",
      params: params,
    });
  },
  /********************************标签管理*********************************** */
  // 添加标签
  addTags(params) {
    return ajax({
      url: "/tag/add",
      type: "post",
      params: params,
    });
  },
  // 请求标签列表
  getTagList(params) {
    return ajax({
      url: "/tag/list",
      type: "get",
      params: params,
    });
  },
  // 请求推荐标签列表
  getRecmdList(params) {
    return ajax({
      url: "/recmd/list",
      type: "get",
      params: params,
    });
  },
  // 请求新增推荐标签
  addRecmdList(params) {
    return ajax({
      url: "/recmd/add",
      type: "post",
      params: params,
    });
  },
  // 编辑推荐标签
  editRecmdList(params) {
    return ajax({
      url: "/recmd/update",
      type: "post",
      params: params,
    });
  },
  // 删除推荐标签
  deleteRecmdList(params) {
    return ajax({
      url: "/recmd/delete",
      type: "delete",
      params: params,
    });
  },
  // 删除tags
  deleteTags(params) {
    return ajax({
      url: "/tag/delete",
      type: "delete",
      params: params,
    });
  },
  // 编辑标签
  editTags(params) {
    return ajax({
      url: "/tag/update",
      type: "post",
      params: params,
    });
  },
  // 推送至精彩
  pushWonder(params) {
    return ajax({
      url: "/vid/wonder/add",
      type: "post",
      params: params,
    });
  },
  /********************************发现精彩*********************************** */
  // 删除推荐精彩
  deleteWonder(params) {
    return ajax({
      url: "/vid/wonder/delete",
      type: "delete",
      params: params,
    });
  },
  // 获取精彩视频列表
  getWonderList(params) {
    return ajax({
      url: "/vid/wonder/list",
      type: "get",
      params: params,
    });
  },
  // 编辑发现精彩
  editWonder(params) {
    return ajax({
      url: "/vid/wonder/update",
      type: "post",
      params: params,
    });
  },
  /********************************视频热度计算方式*********************************** */
  // 获取视频热度计算方式
  queryVidPopularity(params) {
    return ajax({
      url: "/vid/popularity/config",
      type: "get",
      params,
    });
  },
  // 修改视频热度计算方式
  modifyVidPopularity(params) {
    return ajax({
      url: "/vid/popularity/config",
      type: "post",
      params,
    });
  },
  /********************************资源管理*********************************** */
  // 删除资源
  deleteSource(params) {
    return ajax({
      url: "/source/del",
      type: "delete",
      params: params,
    });
  },
  // 获取资源列表
  getSourceList(params) {
    return ajax({
      url: "/source/list",
      type: "get",
      params: params,
    });
  },
  // 添加资源
  addSource(params) {
    return ajax({
      url: "/source/add",
      type: "post",
      params: params,
    });
  },
  // 编辑资源
  editSource(params) {
    return ajax({
      url: "/source/edit",
      type: "post",
      params: params,
    });
  },
  /********************************过滤词管理*********************************** */
  // 过滤词列表
  filterList(params) {
    return ajax({
      url: "/filter/list",
      type: "get",
      params: params,
    });
  },
  // 过滤词删除
  filterDelete(params) {
    return ajax({
      url: "/filter/delete",
      type: "delete",
      params: params,
    });
  },
  // 过滤词添加
  filterAdd(params) {
    return ajax({
      url: "/filter/add",
      type: "post",
      params: params,
    });
  },

  /***********************免费视频观看配置列表************************ */
  // 过滤词列表
  // 删除
  deletefreeVid(params) {
    return ajax({
      url: "/freeVid/cfg/del",
      type: "delete",
      params: params,
    });
  },
  // 获取请求列表
  getfreeVidList(params) {
    return ajax({
      url: "/freeVid/cfg/list",
      type: "get",
      params: params,
    });
  },
  // 添加
  addfreeVid(params) {
    return ajax({
      url: "/freeVid/cfg/add",
      type: "post",
      params: params,
    });
  },
  // 编辑
  editfreeVid(params) {
    return ajax({
      url: "/freeVid/cfg/edit",
      type: "post",
      params: params,
    });
  },

  /***********************活动配置************************ */

  // 查询活动配置
  queryActiveConfig(params) {
    return ajax({
      url: "/video_activity",
      type: "get",
      params: params,
    });
  },

  // 新增活动配置
  addActiveConfig(params) {
    return ajax({
      url: "/video_activity",
      type: "post",
      params: params,
    });
  },

  // 编辑活动配置
  eidtActiveConfig(params) {
    return ajax({
      url: "/video_activity",
      type: "put",
      params: params,
    });
  },

  /***********************视频资源库************************ */
  // 查询资源库列表
  queryMediaResConfig(params) {
    return ajax({
      url: "/mediaResource/list",
      type: "get",
      params: params,
    });
  },
  // 使用
  useMediaRes(params) {
    return ajax({
      url: "/mediaResource/use",
      type: "post",
      params: params,
    });
  },
  // 使用
  ignoreMediaRes(params) {
    return ajax({
      url: "/mediaResource/ignore",
      type: "post",
      params: params,
    });
  },
  /***********************热搜词************************ */
  // 查询热搜词列表
  queryHotSearchWords(params) {
    return ajax({
      url: "/hotsearch/list",
      type: "get",
      params: params,
    });
  },
  // 新增热搜词
  addHotSearchWord(params) {
    return ajax({
      url: "/hotsearch/create",
      type: "post",
      params: params,
    });
  },
  // 删除热搜词
  delHotSearchWord(params) {
    return ajax({
      url: "/hotsearch/delete",
      type: "post",
      params: params,
    });
  },
  // 修改热搜词
  updateHotSearchWord(params) {
    return ajax({
      url: "/hotsearch/update",
      type: "post",
      params: params,
    });
  },
};
export default videoApi;
